import { Link, useLocation } from 'react-router-dom';
import { ArrowRightOnRectangleIcon, UserPlusIcon } from '@heroicons/react/24/outline';

interface MainNavProps {
  title?: string;
  subtitle?: string;
}

export function MainNav({ title, subtitle }: MainNavProps) {
  const location = useLocation();

  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <header className="border-b border-white/10 bg-black">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo-icon.png" alt="Argos Tellus" className="h-8 w-8 object-contain" />
            <div className="flex items-baseline gap-2">
              <span className="text-xl font-bold text-white tracking-[0.3em] font-orbitron">{title || 'ARGOS'}</span>
              {subtitle && (
                <span className="text-[10px] text-white/50 tracking-wider hidden sm:inline font-inter">{subtitle}</span>
              )}
            </div>
          </Link>

          {/* Navigation */}
          <nav className="flex items-center gap-1 sm:gap-2">
            <Link
              to="/client/signup"
              className={`flex items-center gap-2 px-3 py-2 text-xs tracking-widest transition-colors ${
                isActive('/client/signup') || isActive('/signup')
                  ? 'text-cyan-400 bg-cyan-500/10'
                  : 'text-white/50 hover:text-cyan-400 hover:bg-cyan-500/5'
              }`}
            >
              <UserPlusIcon className="h-4 w-4" />
              <span className="hidden sm:inline">SIGNUP</span>
            </Link>

            <Link
              to="/login"
              className={`flex items-center gap-2 px-3 py-2 text-xs tracking-widest transition-colors ${
                isActive('/login')
                  ? 'text-cyan-400 bg-cyan-500/10'
                  : 'text-white/50 hover:text-cyan-400 hover:bg-cyan-500/5'
              }`}
            >
              <ArrowRightOnRectangleIcon className="h-4 w-4" />
              <span className="hidden sm:inline">LOGIN</span>
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
